import { ApiResult, FieldType, ViewModelBase, isEmptyOrWhitespace, observable } from "@shoothill/core";
import {
    RDDV2CategoryDTO,
    RDDV2StatusDTO,
    RDDV2SupplierDTO,
    RDDV2RequestedByDTO,
    RDDV2RelatedResultResponseDTO,
    UpsertCategoryRDDV2sAndRelatedRequestDTO,
    RDDV2CreateFormItemsModel,
    RDDV2ProjectDetailsDTO,
    RDDV2ProjectDirectoryPersonDTO,
} from "./RDDV2CreateFormItemsModel";
import moment from "moment";
import { uniqueId } from "lodash-es";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";
import { AppUrls } from "AppUrls";
import { runInAction, action, computed } from "mobx";
import { RDDV2DTO } from "../Edit/RDDV2FormModel";
import { RDDV2FormFileModel, RDDV2FileDTO } from "../Common/RDDV2FormFileModel";
import { RDDV2FormDocumentModel, RDDV2DocumentDTO } from "../Common/RDDV2FormDocumentModel";
import { RDDV2FormDocumentViewModel } from "../Common/RDDV2FormDocumentViewModel";
import { RDDV2FormCategoryDocumentViewModel } from "../Common/RDDV2FormCategoryDocumentViewModel";
import { RDDV2FormFileViewModel } from "../Common/RDDV2FormFileViewModel";
import { RDDV2CreateFormModel } from "./RDDV2CreateFormModel";
import { RDDV2CreateFormItemViewModel } from "./RDDV2CreateFormItemViewModel";

export class RDDV2CreateFormViewModel extends ViewModelBase<RDDV2CreateFormItemsModel> {
    constructor(projectId: string | null) {
        super(new RDDV2CreateFormItemsModel());
        this.setDecorators(RDDV2CreateFormItemsModel);
        this.model.projectId = projectId!;
        this.loadRelated();
    }

    public server: ServerViewModel = new ServerViewModel();

    @observable
    public snackMessage = "";

    @observable
    public snackType = "";

    @observable
    public SNACKSUCCESS = "success";

    @observable
    public SNACKERROR = "error";

    @observable
    public snackbarState = false;

    @observable
    public title: any = null;

    @observable
    public description: any = null;

    @observable
    public uniqueId: string = "";

    @observable
    public statuses = observable<RDDV2StatusDTO>([]);

    @observable
    public projectDirectoryPersons = observable<RDDV2ProjectDirectoryPersonDTO>([]);

    @observable
    public supplier: { id: string; displayName: string } | null = null;

    @observable
    public category: { id: string; displayName: string } | null = null;

    @observable
    public status: { id: string; displayName: string } | null = null;

    @observable
    public rddV2TempViewModel: RDDV2CreateFormItemViewModel | null = null;

    @observable
    public requestedBy: { id: string; displayName: string } | null = null;

    @observable
    public clientReference: { id: string; displayName: string } | null = null;

    @observable
    public suppliers = observable<RDDV2SupplierDTO>([]);

    @observable
    public categories = observable<RDDV2CategoryDTO>([]);

    @observable
    public requestedByUsers = observable<RDDV2RequestedByDTO>([]);

    @observable
    public rddV2ProjectDetails: RDDV2ProjectDetailsDTO | null = null;

    @observable
    public rddV2CreateFormModels: RDDV2CreateFormModel[] = [];

    @observable
    public rddV2CreateFormItemViewModels: RDDV2CreateFormItemViewModel[] = [];

    @observable
    public rddV2TempCreateFormItemViewModels: RDDV2CreateFormItemViewModel[] = [];

    @observable
    public rddV2FileViewModels: RDDV2FormFileViewModel[] = [];

    @observable
    public rddV2CategoryDocumentViewModels: RDDV2FormCategoryDocumentViewModel[] = [];

    @observable
    public rddV2DocumentViewModels: RDDV2FormDocumentViewModel[] = [];

    @observable
    public hasLoaded: boolean = false;

    @computed
    public get getHasLoaded(): boolean {
        return this.hasLoaded;
    }

    @action
    public getFormTitle(isrevision: string): string {
        return "New RDD";
    }

    @action
    public getSupplier(supplierId: string | null): string | undefined {
        const supplier: string | undefined = this.suppliers.find((s) => s.id === supplierId)?.displayName;
        return supplier ? supplier : "Darwin Group";
    }

    @action
    public setHasLoaded = (val: boolean) => {
        this.hasLoaded = val;
    };

    @action
    public setSnackMessage = (val: string) => {
        this.snackMessage = val;
    };

    @action
    public setSnackType = (val: string) => {
        this.snackType = val;
    };

    @action
    public setSnackbarState = (val: boolean) => {
        this.snackbarState = val;
    };

    @action
    public addTempRDDV2 = () => {
        this.uniqueId = uniqueId();
        this.rddV2TempViewModel = null;
        let model = new RDDV2CreateFormModel();
        model.uniqueId = this.uniqueId;
        this.rddV2TempViewModel = new RDDV2CreateFormItemViewModel(model);
        this.rddV2TempCreateFormItemViewModels.push(this.rddV2TempViewModel);
    };

    @action
    public addRDDV2Item = async () => {
        if ((await this.rddV2TempViewModel?.isModelValid()) === true) {
            let model = new RDDV2CreateFormModel();
            model.projectId = this.model.projectId;
            model.uniqueId = this.rddV2TempViewModel?.getValue("uniqueId") ? this.rddV2TempViewModel?.getValue("uniqueId") : "";
            model.rddV2CategoryId = this.rddV2TempViewModel?.getValue("rddV2CategoryId") ? this.rddV2TempViewModel?.getValue("rddV2CategoryId") : "";
            model.title = this.rddV2TempViewModel?.getValue("title") ? this.rddV2TempViewModel?.getValue("title") : "";
            model.description = this.rddV2TempViewModel?.getValue("description") ? this.rddV2TempViewModel?.getValue("description") : "";
            model.supplierReference = this.rddV2TempViewModel?.getValue("supplierReference") ? this.rddV2TempViewModel?.getValue("supplierReference") : "";
            model.supplierId = this.rddV2TempViewModel?.getValue("supplierId") ? this.rddV2TempViewModel?.getValue("supplierId") : "";
            model.rddV2StatusId = this.rddV2TempViewModel?.getValue("rddV2StatusId") ? this.rddV2TempViewModel?.getValue("rddV2StatusId") : "";
            model.requestedDate = this.rddV2TempViewModel?.getValue("requestedDate") ? this.rddV2TempViewModel?.getValue("requestedDate") : null;
            model.responseRequiredByDate = this.rddV2TempViewModel?.getValue("responseRequiredByDate") ? this.rddV2TempViewModel?.getValue("responseRequiredByDate") : null;
            model.isFromDarwin = this.rddV2TempViewModel?.getValue("isFromDarwin") ? this.rddV2TempViewModel?.getValue("isFromDarwin") : false;
            runInAction(() => {
                if (this.rddV2TempViewModel) {
                    this.rddV2TempViewModel.rddV2FileViewModels.forEach((attachment) => {
                        let attachmentToAdd = new RDDV2FormFileModel();
                        attachmentToAdd.uniqueId = model.uniqueId;
                        attachmentToAdd.fileName = attachment.model.fileName;
                        attachmentToAdd.fileURL = attachment.model.fileURL;
                        this.model.rddV2Attachments.push(attachmentToAdd);
                        let attachmentToAddViewModel = new RDDV2FormFileViewModel(attachmentToAdd);
                        this.rddV2FileViewModels.push(attachmentToAddViewModel);
                    });
                }
                this.model.rddV2Items.push(model);
                let viewModel = new RDDV2CreateFormItemViewModel(model);
                this.rddV2CreateFormItemViewModels.push(viewModel);
                this.rddV2TempCreateFormItemViewModels.pop();
                this.addTempRDDV2();
            });
            return true;
        }
        return false;
    };

    @action
    public deleteRDDV2Item(indexToDelete: number) {
        this.rddV2CreateFormItemViewModels.forEach((rddV2, index) => {
            if (index === indexToDelete) {
                this.rddV2CreateFormItemViewModels.splice(index, 1);
            }
        });
    }

    @action
    public reset = () => {
        this.model.reset();
        this.server.reset();
    };

    @action
    public handleCancel(projectId: string | null): void {
        this.reset();
        this.history.push(AppUrls.Client.Project.ReviewableDesignDataV2.replace(":projectid", projectId ? projectId : this.model.projectId));
    }

    @action
    public fileChangeForCategory = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
        if (event.target.files !== null && event.target.value !== null && event.target.files.length > 0) {
            let data: any = {
                fileName: event.target.files[0].name,
                formFile: event.target.files[0],
            };
            event.target.value = "";
            const apiResult = await this.fileUpload(data);
            if (apiResult && apiResult.wasSuccessful) {
                runInAction(() => {
                    let model = new RDDV2FormDocumentModel();
                    model.rddV2Id = "";
                    model.fileName = data.fileName;
                    model.fileURL = apiResult.payload;
                    model.isDeleted = false;
                    model.createdByUserId = null;
                    this.model.rddV2Documents.push(model);
                    let viewModel = new RDDV2FormDocumentViewModel(model);
                    this.rddV2DocumentViewModels.push(viewModel);
                });
            }
        }
    };

    /**
     * Upload a file to azure.
     * @param data The data of the file to be uploaded.
     * @returns apiResult.
     */
    public fileUpload = async (data: any): Promise<ApiResult<any>> => {
        const formData = new FormData();
        formData.append("formFile", data.formFile);
        formData.append("fileName", data.fileName);
        const apiResult = await this.Post<any>(AppUrls.Server.File.UploadFile, formData);
        if (apiResult) {
            if (!apiResult.wasSuccessful) {
                console.log(apiResult.errors);
                runInAction(() => {
                    this.setSnackMessage("Error uploading file please try again.");
                    this.setSnackType(this.SNACKERROR);
                    this.setSnackbarState(true);
                });
            }
        }
        return apiResult;
    };
    /**
     * Download a file that exists in azure.
     * @param fileUrl The URL of the file to be downloaded.
     * @param fileName The name of the file to be downloaded.
     */
    public DownloadFile = async (fileUrl: string, fileName: string): Promise<void> => {
        try {
            const apiResult = await this.Post<Blob>(AppUrls.Server.File.DownloadFile, fileUrl, undefined, { responseType: "blob" });
            const response = apiResult as any;
            const url = window.URL.createObjectURL(new Blob([response]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
        } catch (exception) {
            console.error(exception);
            this.setIsErrored(true);
        }
    };

    @action
    public deleteRDDV2Attachment = async (index: number): Promise<void> => {
        this.rddV2FileViewModels[index].model.isDeleted = true;
    };

    @action
    public deleteRDDV2Document = async (index: number): Promise<void> => {
        this.rddV2DocumentViewModels[index].model.isDeleted = true;
    };

    @computed
    public get getTodayDateFormatted(): string {
        return moment().format("DD/MM/YYYY @ HH:mm").toString();
    }

    @computed
    public get getProjectReferenceFormatted(): string {
        if (!this.rddV2ProjectDetails) {
            return "";
        }
        return this.rddV2ProjectDetails.projectReference;
    }

    @computed
    public get getProjectName(): string {
        if (!this.rddV2ProjectDetails) {
            return "";
        }
        return this.rddV2ProjectDetails.projectName;
    }

    public loadRelated = async (): Promise<void> => {
        this.setIsLoading(true);
        return await this.server
            .query<RDDV2RelatedResultResponseDTO>(
                () => this.Get(`${AppUrls.Server.Projects.ProjectTrackers.RDDV2.GetRDDV2Related}\\${this.model.projectId}`),
                (result) => {
                    runInAction(() => {
                        this.categories.replace(result.categories);
                        this.suppliers.replace(result.suppliers);
                        this.statuses.replace(result.statuses);
                        this.projectDirectoryPersons.replace(result.projectDirectoryPersons);
                        this.rddV2ProjectDetails = result.rddV2ProjectDetails;
                        this.addTempRDDV2();
                    });
                },
            )
            .finally(() => {
                this.setIsLoading(false);
                this.setHasLoaded(true);
            });
    };

    public upsert = async (): Promise<void> => {
        this.setIsLoading(true);
        let rddV2sToAdd: RDDV2DTO[] = [];
        let attachmentsToAdd: RDDV2FileDTO[] = [];
        let documentsToAdd: RDDV2DocumentDTO[] = [];

        this.rddV2CreateFormItemViewModels.forEach((item) => {
            const rddV2ToAdd: RDDV2DTO = item.model.toDto();
            rddV2ToAdd.clientReference = 0;
            rddV2sToAdd.push(rddV2ToAdd);
        });

        this.rddV2FileViewModels.forEach((attachment) => {
            const attachmentToAdd: RDDV2FileDTO = attachment.model.toDto();
            attachmentsToAdd.push(attachmentToAdd);
        });

        this.rddV2DocumentViewModels.forEach((item) => {
            const documentToAdd: RDDV2DocumentDTO = item.model.toDto();
            documentToAdd.rddV2Id = "";
            //documentToAdd.RDDV2CategoryId = this.model.RDDV2CategoryId;
            documentsToAdd.push(documentToAdd);
        });

        const request: UpsertCategoryRDDV2sAndRelatedRequestDTO = {
            projectId: this.model.projectId,
            //RDDV2CategoryId: this.model.RDDV2CategoryId,
            rddV2Items: rddV2sToAdd,
            rddV2Documents: documentsToAdd,
            rddV2Attachments: attachmentsToAdd,
        };

        return await this.server
            .command<RDDV2RelatedResultResponseDTO>(
                () => this.Post(AppUrls.Server.Projects.ProjectTrackers.RDDV2.Create, request),
                (result: RDDV2RelatedResultResponseDTO) => {
                    runInAction(() => {
                        if (result) {
                            this.handleCancel(this.model.projectId);
                        }
                    });
                },
                this.isMyModelValid,
                "There was an error trying to send the Reviewable Design Data",
            )
            .finally(() => this.setIsLoading(false));
    };

    private isMyModelValid = async (): Promise<boolean> => {
        let isValid = true;

        for (let i = 0; i < this.rddV2CreateFormItemViewModels.length; i++) {
            let item = this.rddV2CreateFormItemViewModels[i];

            // Validate each child.
            if ((await item.isModelValid()) === false) {
                isValid = false;
            }
        }

        if ((await this.isModelValid()) === false) {
            isValid = false;
        }

        return isValid;
    };

    public async isFieldValid(fieldName: keyof FieldType<RDDV2CreateFormItemsModel>): Promise<boolean> {
        return true;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
